module.exports = __webpack_public_path__ + "static/media/img_1.4d05d4a7.png";